import React, { memo } from 'react';

import { TaskBoard } from '../../_detailShared/TaskBoard';

interface ITasksTabProps {
  groupId: string;
}

/**
 * Group "Задачи" tab (spec 0003 redesign follow-up) — the shared bucketed task
 * board scoped to this group: overdue / today / tomorrow / this-week / later /
 * no-date all visible at once, with a due-date range + search and an inline
 * create form (roster picker → student · agreement). Split out of the
 * communication tab so tasks have their own home.
 */
export const TasksTab = memo(({ groupId }: ITasksTabProps) => (
  <TaskBoard groupId={groupId} showCreateForm />
));

TasksTab.displayName = 'TasksTab';
